module.exports = __webpack_public_path__ + "static/img/yytx12.0ce8cec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx12.png
// module id = 884
// module chunks = 0